import 'react-multi-carousel/lib/styles.css';
import * as React from 'react';
import Link from 'next/link';
import FastEasy from '../components/FastEasy';
import Button from '@mui/material/Button';
import DontWaitBannerSection from 'components/composed/sections/DontWaitBannerSection';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { NextSeo } from 'next-seo';
import { config } from '_config';

const { apiUrl } = config;

export default function OfficeAction() {
  const [productName, setProductName] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );
    let url = apiUrl + '/category/TRADEMARKS/products/prices';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices';

    axios
      .get(url, {
        params: {
          onlyForSale: true,
          productCodes: 'TRADEMARK_Trademark_Office_Action_Response',
          processingOptions: 'STANDARD',
        },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          setProductName(response.data[0].code.customerName);
          setProductPrice(response.data[0].price);
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              params: {
                onlyForSale: true,
                productCodes: 'TRADEMARK_Trademark_Office_Action_Response',
                processingOptions: 'STANDARD',
              },
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200 && response.data.length > 0) {
                setProductName(response.data[0].code.customerName);
                setProductPrice(response.data[0].price);
              }
            });
        }
      });
  }, []);

  return (
    <div className="action">
      <NextSeo title="Office Action Response" />
      <div className="banner">
        <div className="copy-wrapper">
          <div className="copy">
            <h1>Office Action Response</h1>
            <p>
              Don't give up on your trademark or miss the response deadline!
              Responses to the USPTO must be filed within 6 months of the
              mailing date printed on the Office Action document.
            </p>
            <div className="btn-wrapper">
              <Link href="/office-action-response">
                <a className="orange-btn">File Office Action Now</a>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <FastEasy
        text={[
          {
            h: 'Complete Our Online Questionnaire',
            p: 'All information gathered is confidential and secured.',
          },
          {
            h: 'Our Specialists Prepare Your Office Action Response',
            p: 'Your Office Action issues are evaluated to verify eligibility for our handling. Once verified, the response is prepared and reviewed for submission.',
          },
          {
            h: 'The Office Action Response is Filed with the UPSTO',
            p: 'The response is reviewed with you prior to submission. Once approved and submitted, we will update you will all status changes.',
          },
        ]}
      />

      <div className="sides">
        <div className="sides-wrapper">
          <div className="left-side">
            <h3>Determining Issues to Be Addressed in Response</h3>
            <p>
              Enter your serial number in the search bar of the USPTO trademark
              status page:
            </p>
            <input type="text" />
            <textarea />
            <p className="small">
              Within the documents section, select the "Office Action" document
              to review the issues brought forth by the UPSTO concerning your
              application.
            </p>
            <Button>Documents</Button>
            <Button>Status</Button>
          </div>
          <div className="right-side">
            <div className="side-box-wrapper">
              <div className="side-box-back-2"></div>
              <div className="side-box-back"></div>
              <div className="side-box">
                <div className="header-line"></div>
                <h4>{productName}</h4>
                <h5>We’ll help you overcome your Office Action.</h5>
                <div className="orange-box">
                  <div className="star"></div>
                  <div className="price-wrapper">
                    <div className="price">
                      {'$' + productPrice?.toFixed(2)}
                    </div>
                    <p>per filing</p>
                  </div>
                  <div className="star"></div>
                </div>

                <p>Assessment of response eligibility</p>
                <ul>
                  <li>
                    <span></span>
                    <p>
                      Professionally formatted report and review done by
                      specialists
                    </p>
                  </li>
                  <li>
                    <span></span>
                    <p>High approval rate from our responses</p>
                  </li>
                </ul>
                <Link href="/office-action-response">
                  <Button>Start Now</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DontWaitBannerSection link={'/office-action-response'} />
    </div>
  );
}
